export default __webpack_public_path__ + "yellowmap.svg?919a3bf906feba507f07111e487fc3ff";